<script setup lang="ts">
import {Swiper, SwiperSlide} from 'swiper/vue'

// Import Swiper styles
// oxlint-disable-next-line import/no-unassigned-import
import 'swiper/css'

// oxlint-disable-next-line import/no-unassigned-import
import 'swiper/css/effect-coverflow'
// oxlint-disable-next-line import/no-unassigned-import
import 'swiper/css/pagination'

// import required modules
import {EffectCoverflow, Pagination, Virtual} from 'swiper/modules'

const breakpoints = {
  '375': {
    coverflowEffect: {
      rotate: 0,
      depth: 200,
      modifier: 1,
      stretch: 0,
      slideShadows: true,
    },
  },
  '640': {
    coverflowEffect: {
      rotate: 0,
      depth: 200,
      modifier: 1,
      stretch: 0,
      slideShadows: true,
    },
  },
  '768': {
    coverflowEffect: {
      rotate: 0,
      depth: 200,
      modifier: 1,
      stretch: 0,
      slideShadows: true,
    },
  },
  '1024': {
    coverflowEffect: {
      rotate: 0,
      depth: 200,
      modifier: 1,
      stretch: 0,
      slideShadows: true,
    },
  },
  '1280': {
    coverflowEffect: {
      rotate: 0,
      depth: 200,
      modifier: 1,
      stretch: 0,
      slideShadows: true,
    },
  },
}

const {fetch} = useEmployeeTestimonials()
const {pending, data: testimonials} = await useAsyncData('employeeTestimonials', () => fetch())
</script>

<template>
  <swiper
    v-if="!pending"
    effect="coverflow"
    :grabCursor="true"
    :centeredSlides="true"
    slidesPerView="auto"
    :coverflowEffect="{
      rotate: 0,
      depth: 1000,
      modifier: 1,
      stretch: 0,
      slideShadows: false,
    }"
    :breakpoints="breakpoints"
    :pagination="false"
    :modules="[EffectCoverflow, Pagination, Virtual]"
    class="!overflow-visible"
  >
    <swiper-slide
      v-for="(item, i) in testimonials"
      :key="item.name! + i"
      :index="i"
      :virtualIndex="i"
      class="overflow-hidden rounded-3xl"
    >
      <div
        class="relative h-full w-full bg-cover text-white sm:text-primary-dark md:text-lg"
        :style="{backgroundImage: `url(${item.portrait.url ?? ''})`}"
      >
        <img v-bind="resolveMediaProps(item.portrait)" class="absolute z-0 h-full w-full rounded-3xl object-cover" />
        <div
          :class="[
            'absolute inset-0 z-0 h-full w-full',
            'bg-gradient-to-t from-primary-dark to-transparent opacity-60',
          ]"
        />
        <div
          :class="[
            'absolute inset-0 z-10 h-full w-full',
            'flex flex-col justify-end gap-4',
            'px-4 py-4 sm:px-8 sm:py-8 lg:px-11 lg:py-14',
          ]"
        >
          <p>
            {{ item.quote }}
          </p>
          <div class="flex flex-col lg:flex-row">
            <span class="font-bold">{{ item.name }}</span>
            <span>&nbsp;― {{ item.role }}</span>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper>
</template>

<style lang="postcss">
.swiper {
  --carousel-item-width: 300px;
  --carousel-item-height: 420px;
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
}

@media screen and (min-width: 640px) {
  .swiper {
    --carousel-item-width: 300px;
    --carousel-item-height: 420px;
    --carousel-height: 420px;
  }
}
@media screen and (min-width: 768px) {
  .swiper {
    --carousel-item-width: 300px;
    --carousel-item-height: 420px;
    --carousel-height: 420px;
  }
}
@media screen and (min-width: 1024px) {
  .swiper {
    --carousel-item-width: 394px;
    --carousel-item-height: 515px;
    --carousel-height: 600px;
  }
}
@media screen and (min-width: 1280px) {
  .swiper {
    --carousel-item-width: 515px;
    --carousel-item-height: 675px;
    --carousel-height: 800px;
  }
}

.swiper-slide {
  width: var(--carousel-item-width) !important;
  height: var(--carousel-item-height) !important;
}
</style>
